<template>
    <!-- Blog Post -->
    <div class="card mb-4">
        <img v-if="blogPost.tipoatracao==2" class="card-img-top" :src="`https://${this.location}/images/blog/posts/${blogPost.atracao}`" alt="Imagem do post">
        <div class="embed-responsive embed-responsive-16by9" v-if="blogPost.tipoatracao == 1">
            <iframe class="embed-responsive-item" :src="`https://www.youtube.com/embed/${blogPost.atracao}`" frameborder="0" 
            allow="accelerometer; autoplay; encrypted-media; gyroscope" allowfullscreen></iframe>
        </div>
        <div class="card-body">
        <h2 class="card-title">{{ blogPost.titulo }}</h2>
        <p class="card-text">{{ blogPost.subtitulo }}</p>
        <a href="#" @click.prevent="viewPost(blogPost)" class="btn btn-primary">Leia mais →</a>
        </div>
        <div class="card-footer text-muted">
        Publicado {{ blogPost.criado }} por
        <span class="text-black">
        {{ blogPost.autor }}
        </span>
        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return {
                location: window.location.host
            }
        },
        mounted() {
        },
        props: {
            blogPost: {
                required: true
            }
        },
        methods: {
            viewPost(post){
                console.log(post);
                this.$parent.viewPost(post);
            }
        }
    }
</script>
